// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"b2373950","171":"8b004d81","179":"f001f7af","202":"52cb64cd","254":"b6a58bba","487":"658bb743","559":"b1d1a8a0","674":"462f3bf7","960":"fa8dfc28"}[chunkId] + ".css";
};